export class Mensagens {

    static get OcorreuErroInesperado(): string {
        return 'Ocorreu um erro inesperado. Entre em contato com o administrador do sistema.';
    }

    static get NaoPossuiPermissaoOuSessaoExpirou(): string {
        return 'Você não possui permissão para acessar esta funcionalidade ou sua sessão expirou.';
    }

    // Usuário

    public static UsuarioCadastradoComSucessoMensagem(): string {
        return 'O Usuário foi cadastrado com sucesso.';
    }

    public static UsuarioAtualizadoComSucessoMensagem(): string {
        return 'O Usuário foi atualizado com sucesso.';
    }

    public static UsuarioExcluidoComSucessoMensagem(): string {
        return 'O Usuário foi desativado com sucesso.';
    }

    // Perfil

    public static PerfilExcluidoComSucessoMensagem(): string {
        return 'O Perfil foi desativado com sucesso.';
    }

    public static PerfilAtualizadoComSucessoMensagem(): string {
        return 'O Perfil foi atualizado com sucesso.';
    }

    public static PerfilCadastradoComSucessoMensagem(): string {
        return 'O Perfil foi cadastrado com sucesso.';
    }

    // Módulo

    public static ModuloExcluidoComSucessoMensagem(): string {
        return 'O Módulo foi desativado com sucesso.';
    }

    public static ModuloAtualizadoComSucessoMensagem(): string {
        return 'O Módulo foi atualizado com sucesso.';
    }

    public static ModuloCadastradoComSucessoMensagem(): string {
        return 'O Módulo foi cadastrado com sucesso.';
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/utils/mensagens.ts